var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriangleRight = function SvgTriangleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.918 8.937c1.366.762 1.371 1.72 0 2.58L6.32 18.666c-1.332.71-2.236.29-2.331-1.247L3.945 2.46C3.915 1.044 5.082.643 6.193 1.322l10.725 7.615Z"
  })));
};
export default SvgTriangleRight;